var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mt-1"},[_c('div',[_c('v-btn',{staticClass:"mr-4 mt-4",attrs:{"block":"","color":"primary","loading":_vm.loading,"disabled":_vm.dataBtnDisabled,"type":"submit"},on:{"click":_vm.submitData}},[_vm._t("default",function(){return [_vm._v("SUBMIT")]})],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }